import React from 'react';
import PropTypes from 'prop-types';
import text from '@ux/text';
import classNames from 'classnames';

/**
 * Navigation heading component
 *
 * @param {Object} props Props
 * @param {string} props.text Text of heading
 * @param {Object} props.afterNavHeadingLeft Node injected immediately next to the heading, on the left side
 * @returns {React.ReactElement} Rendered heading
 * @private
 */
function Headline({ text: txt, afterNavHeadingLeft }) {
  const classname = classNames('nav-heading', { 'with-headline-right': !!afterNavHeadingLeft });
  return (
    <div className='headline-wrapper'>
      <text.h1 as='heading' className={ classname } text={ txt } />
      { afterNavHeadingLeft }
    </div>
  );
}

Headline.propTypes = {
  text: PropTypes.string.isRequired,
  afterNavHeadingLeft: PropTypes.node
};

export default Headline;
